import React from "react";

export const ReactLazyLoading = (fun: () => Promise<{ default: React.ComponentType<any> }>) => {
  const Component = React.lazy(fun);

  return (props: any) => <Component {...props} />;
};
